import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root', // Makes the service a singleton, available application-wide
})
export class StorageService {
  prefix: string = 'serveto_';

  private storage: Storage = localStorage;

  // Subject to emit when user profile changes
  private userProfileChangeSource = new Subject<void>();
  userProfileChange$ = this.userProfileChangeSource.asObservable();

  setItem(key: string, value: any): void {
    this.storage.setItem(this.prefix + key, JSON.stringify(value));

    // If the user profile is being updated, notify subscribers
    if (key === 'user_profile') {
      this.userProfileChangeSource.next();
    }
  }

  // Get an item from storage
  getItem<T>(key: string): T | null {
    const item = this.storage.getItem(this.prefix + key);
    return item ? JSON.parse(item) : null;
  }

  // Remove an item from storage
  removeItem(key: string): void {
    this.storage.removeItem(this.prefix + key);

    // If the user profile is being removed, notify subscribers
    if (key === 'user_profile') {
      this.userProfileChangeSource.next();
    }
  }

  // Clear all storage
  clear(): void {
    this.storage.clear();
  }

  getAllItems(): Record<string, any> {
    const items: Record<string, any> = {};
    Object.keys(this.storage).forEach((key) => {
      if (key.startsWith(this.prefix)) {
        const itemKey = key.replace(this.prefix, '');
        items[itemKey] = JSON.parse(this.storage.getItem(key) || '{}');
      }
    });
    return items;
  }
}
